<template>
  <div class="top clear">
    <div class="person">
      <span>欢迎您：李伟</span>
      <span class="prev">|</span>
      <span>
        <a href="javascript:;">官网首页</a>
      </span>
      <span class="prev">|</span>
      <el-dropdown @command="getItem">
        <span class="el-dropdown-link">
          我的账户
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="loginOut">安全退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="logo">
      <a href="javascript:;">
        <img src="../assets/icon.png" />
      </a>
    </div>

    <div class="title">后台管理中心</div>
    <div class="tab">
      <ul class="clear">
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ 'current' : menuCurrent == item.path }"
        >
          <a href="javascript:;" @click="getCurrent(item)">{{ item.name }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      // 菜单列表
      menuList: [
        {
          name: "概览",
          path: "index",
          children: []
        },
        {
          name: "用户管理",
          path: "user",
          children: [
            {
              name: "用户管理",
              path: "",
              children: [
                {
                  name: "用户列表",
                  path: "user_userlist"
                },
                {
                  name: "黑名单列表",
                  path: "user_userblacklist"
                },
                {
                  name: "用户文章收藏列表",
                  path: "user_usercollectionlist"
                },
                {
                  name: "关注粉丝列表",
                  path: "user_userfanslist"
                },
                {
                  name: "好友列表",
                  path: "user_userfriendlist"
                },
                {
                  name: "留言列表",
                  path: "user_userliuyanlist"
                },
                {
                  name: "访客列表",
                  path: "user_uservisitorlist"
                },
                {
                  name: "好友申请列表",
                  path: "user_friendrequest"
                },
                {
                  name: "第三方登录账号列表",
                  path: "user_thirdloginlist"
                }
              ]
            },
            {
              name: "日志管理",
              path: "",
              children: [
                {
                  name: "用户下载记录",
                  path: "user_userdownloadlist"
                },
                {
                  name: "积分记录列表",
                  path: "user_userintegrallog"
                },
                {
                  name: "金额变化记录",
                  path: "user_usermoneylog"
                },
                {
                  name: "用户操作日志",
                  path: "user_useroperate"
                }
              ]
            },
            {
              name: "消息管理",
              path: "",
              children: [
                {
                  name: "用户消息列表",
                  path: "user_usermessagelist"
                },
                {
                  name: "用户消息回复列表",
                  path: "user_usermessagereplylist"
                },
                {
                  name: "系统消息列表",
                  path: "user_sysmessagelist"
                },
                {
                  name: "系统消息已读列表",
                  path: "user_sysmessagereadlist"
                }
              ]
            }
          ]
        },
        {
          name: "文章管理",
          path: "art",
          children: [
            {
              name: "文章管理",
              path: "",
              children: [
                {
                  name: "文章列表",
                  path: "art_artlist"
                },
                {
                  name: "文章评论列表",
                  path: "art_artcommentlist"
                },
                {
                  name: "文章下载地址列表",
                  path: "art_artdownloadlist"
                },
                {
                  name: "文章图片管理",
                  path: "art_artpiclist"
                },
                {
                  name: "Tags标签库",
                  path: "art_tagslist"
                },
                {
                  name: "文章类别列表",
                  path: "art_arttypelist"
                }
              ]
            }
          ]
        },
        // {
        //   name: "充值管理",
        //   path: "charge",
        //   children: [
        //     {
        //       name: "订单管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "订单列表",
        //           path: "charge_chargelist"
        //         }
        //       ]
        //     },
        //     {
        //       name: "充值统计",
        //       path: "",
        //       children: [
        //         {
        //           name: "每日充值统计",
        //           path: "charge_tjchargedate"
        //         },
        //         {
        //           name: "每月充值统计",
        //           path: "charge_tjchargemonth"
        //         }
        //       ]
        //     },
        //     {
        //       name: "充值卡管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "充值卡列表",
        //           path: "charge_chargecardlist"
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   name: "系统管理",
        //   path: "about",
        //   children: [
        //     {
        //       name: "站内管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "用户反馈列表",
        //           path: "about_contactlist"
        //         },
        //         {
        //           name: "系统配置",
        //           path: "about_configlist"
        //         },
        //         {
        //           name: "站内地图",
        //           path: "about_sitemap"
        //         },
        //         {
        //           name: "留言列表",
        //           path: "about_artapply"
        //         }
        //       ]
        //     },
        //     {
        //       name: "站内新闻",
        //       path: "",
        //       children: [
        //         {
        //           name: "新闻列表",
        //           path: "about_newslist"
        //         },
        //         {
        //           name: "友情链接列表",
        //           path: "about_linklist"
        //         },
        //         {
        //           name: "首页幻灯片列表",
        //           path: "about_slidelist"
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   name: "权限管理",
        //   path: "power",
        //   children: [
        //     {
        //       name: "管理员管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "管理员列表",
        //           path: "power_adminlist"
        //         }
        //       ]
        //     },
        //     {
        //       name: "角色管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "角色列表",
        //           path: "power_rolelist"
        //         }
        //       ]
        //     },
        //     {
        //       name: "菜单管理",
        //       path: "",
        //       children: [
        //         {
        //           name: "菜单列表",
        //           path: "power_menulist"
        //         }
        //       ]
        //     }
        //   ]
        // }
      ],
      menuCurrent: ""
    };
  },
  created() {
    this.menuCurrent = this.menuList[0].path;
    this.getCurrent(this.menuList[0]);
  },
  methods: {
    // 获取当前选择的菜单
    getCurrent(item) {
      this.menuCurrent = item.path;
      this.$emit("currentMenu", item);
    },
    getItem(item) {
      switch (item) {
        // 退出
        case "loginOut":
          this.$router.push({ name: "login" });
          break;
      }
    }
  }
};
</script>

<style scoped>
.top {
  height: 40px;
  background-color: #2a94de;
  color: #ffffff;
}
.logo {
  width: 35px;
  height: 35px;
  overflow: hidden;
  float: left;
  margin-left: 5px;
  margin-top: 5px;
}

.logo img {
  width: 100%;
}

.title {
  float: left;
  height: 40px;
  width: 180px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.tab {
  float: left;
}

.tab ul li {
  float: left;
}

.tab ul li a {
  display: block;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  padding: 0 15px;
}

.tab ul li.current {
  background-color: #096db4;
}

.person {
  float: right;
  margin-right: 10px;
  height: 40px;
  line-height: 40px;
}

.prev {
  padding: 0 10px;
}

.person a {
  color: #ffffff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #ffffff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>